
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gqTQkUcstcJvPx8BkW5jcreooyVXPqSi7ahi1krXot9AMeta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index22T8xdapZHf3r1N6q8BpX96IONYZb2Ttoou5IU9jov4Meta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search0R84IXHY0zvFMNUEpT9CEJtKyvCY71j3ycxoed1YYcEMeta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexjoSH6kST2BLr_IJEpCEgzIKEeYsHQJow2PWOwd5fV9sMeta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93g9WyJ5YcCZLnOayFUbMzA4Qb0MdP3wHKOvnXHn_45o1mcMeta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexAoZZntINffVGQdc8Gt4TAhSnRZ8GM6Smpkko9sSPQE4Meta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93bEJzsRJ0wRx5g5vvN5ShUY4T70F_45WDqLJ7N67Fb9uzEMeta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexM6o_RqEXzerTn2ENTQeiI0Bqdg_45oKoQMCVYwE7QLrakMeta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93w_2nn_45ySS_45qN2ti9epRVFHBH_45wdXUxfxXQJ4TMeZkvUMeta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexK2340D_n9uqOCt8cA_45BM01cGlOurz3ElWDEUgaJ4eZ4Meta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexR8i_45evqnJKKloyztGJOO2ZlzyLjwiDgd7PVszyD94gYMeta } from "/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexAoZZntINffVGQdc8Gt4TAhSnRZ8GM6Smpkko9sSPQE4Meta || {},
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexM6o_RqEXzerTn2ENTQeiI0Bqdg_45oKoQMCVYwE7QLrakMeta || {},
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexK2340D_n9uqOCt8cA_45BM01cGlOurz3ElWDEUgaJ4eZ4Meta || {},
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexR8i_45evqnJKKloyztGJOO2ZlzyLjwiDgd7PVszyD94gYMeta || {},
    component: () => import("/codebuild/output/src2924127286/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]